import _objectSpread from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import $jFibJ$babelruntimehelpersesmextends from "@babel/runtime/helpers/esm/extends";
import $jFibJ$react from "react";
import { createContextScope as $jFibJ$createContextScope } from "@radix-ui/react-context";
import { Primitive as $jFibJ$Primitive } from "@radix-ui/react-primitive";
import { createRovingFocusGroupScope as $jFibJ$createRovingFocusGroupScope, Root as $jFibJ$Root, Item as $jFibJ$Item } from "@radix-ui/react-roving-focus";
import { Toggle as $jFibJ$Toggle } from "@radix-ui/react-toggle";
import { useControllableState as $jFibJ$useControllableState } from "@radix-ui/react-use-controllable-state";
import { useDirection as $jFibJ$useDirection } from "@radix-ui/react-direction";

/* -------------------------------------------------------------------------------------------------
 * ToggleGroup
 * -----------------------------------------------------------------------------------------------*/
var $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME = 'ToggleGroup';
var _$jFibJ$createContext = $jFibJ$createContextScope($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME, [$jFibJ$createRovingFocusGroupScope]),
  _$jFibJ$createContext2 = _slicedToArray(_$jFibJ$createContext, 2),
  $6c1fd9e6a8969628$var$createToggleGroupContext = _$jFibJ$createContext2[0],
  $6c1fd9e6a8969628$export$d1c7c4bcd9f26dd4 = _$jFibJ$createContext2[1];
var $6c1fd9e6a8969628$var$useRovingFocusGroupScope = $jFibJ$createRovingFocusGroupScope();
var $6c1fd9e6a8969628$export$af3ec21f6cfb5e30 = /*#__PURE__*/$jFibJ$react.forwardRef(function (props, forwardedRef) {
  var type = props.type,
    toggleGroupProps = _objectWithoutProperties(props, ["type"]);
  if (type === 'single') {
    var singleProps = toggleGroupProps;
    return /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImplSingle, $jFibJ$babelruntimehelpersesmextends({}, singleProps, {
      ref: forwardedRef
    }));
  }
  if (type === 'multiple') {
    var multipleProps = toggleGroupProps;
    return /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImplMultiple, $jFibJ$babelruntimehelpersesmextends({}, multipleProps, {
      ref: forwardedRef
    }));
  }
  throw new Error("Missing prop `type` expected on `".concat($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME, "`"));
});
/*#__PURE__*/
Object.assign($6c1fd9e6a8969628$export$af3ec21f6cfb5e30, {
  displayName: $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/
var _$6c1fd9e6a8969628$va = $6c1fd9e6a8969628$var$createToggleGroupContext($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME),
  _$6c1fd9e6a8969628$va2 = _slicedToArray(_$6c1fd9e6a8969628$va, 2),
  $6c1fd9e6a8969628$var$ToggleGroupValueProvider = _$6c1fd9e6a8969628$va2[0],
  $6c1fd9e6a8969628$var$useToggleGroupValueContext = _$6c1fd9e6a8969628$va2[1];
var $6c1fd9e6a8969628$var$ToggleGroupImplSingle = /*#__PURE__*/$jFibJ$react.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange = props.onValueChange,
    onValueChange = _props$onValueChange === void 0 ? function () {} : _props$onValueChange,
    toggleGroupSingleProps = _objectWithoutProperties(props, ["value", "defaultValue", "onValueChange"]);
  var _$jFibJ$useControllab = $jFibJ$useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _$jFibJ$useControllab2 = _slicedToArray(_$jFibJ$useControllab, 2),
    value = _$jFibJ$useControllab2[0],
    setValue = _$jFibJ$useControllab2[1];
  return /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupValueProvider, {
    scope: props.__scopeToggleGroup,
    type: "single",
    value: value ? [value] : [],
    onItemActivate: setValue,
    onItemDeactivate: $jFibJ$react.useCallback(function () {
      return setValue('');
    }, [setValue])
  }, /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImpl, $jFibJ$babelruntimehelpersesmextends({}, toggleGroupSingleProps, {
    ref: forwardedRef
  })));
});
var $6c1fd9e6a8969628$var$ToggleGroupImplMultiple = /*#__PURE__*/$jFibJ$react.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange2 = props.onValueChange,
    onValueChange = _props$onValueChange2 === void 0 ? function () {} : _props$onValueChange2,
    toggleGroupMultipleProps = _objectWithoutProperties(props, ["value", "defaultValue", "onValueChange"]);
  var _$jFibJ$useControllab3 = $jFibJ$useControllableState({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _$jFibJ$useControllab4 = _slicedToArray(_$jFibJ$useControllab3, 2),
    _$jFibJ$useControllab5 = _$jFibJ$useControllab4[0],
    value1 = _$jFibJ$useControllab5 === void 0 ? [] : _$jFibJ$useControllab5,
    setValue = _$jFibJ$useControllab4[1];
  var handleButtonActivate = $jFibJ$react.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return [].concat(_toConsumableArray(prevValue), [itemValue]);
    });
  }, [setValue]);
  var handleButtonDeactivate = $jFibJ$react.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return prevValue.filter(function (value) {
        return value !== itemValue;
      });
    });
  }, [setValue]);
  return /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupValueProvider, {
    scope: props.__scopeToggleGroup,
    type: "multiple",
    value: value1,
    onItemActivate: handleButtonActivate,
    onItemDeactivate: handleButtonDeactivate
  }, /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupImpl, $jFibJ$babelruntimehelpersesmextends({}, toggleGroupMultipleProps, {
    ref: forwardedRef
  })));
});
/*#__PURE__*/
Object.assign($6c1fd9e6a8969628$export$af3ec21f6cfb5e30, {
  displayName: $6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/
var _$6c1fd9e6a8969628$va3 = $6c1fd9e6a8969628$var$createToggleGroupContext($6c1fd9e6a8969628$var$TOGGLE_GROUP_NAME),
  _$6c1fd9e6a8969628$va4 = _slicedToArray(_$6c1fd9e6a8969628$va3, 2),
  $6c1fd9e6a8969628$var$ToggleGroupContext = _$6c1fd9e6a8969628$va4[0],
  $6c1fd9e6a8969628$var$useToggleGroupContext = _$6c1fd9e6a8969628$va4[1];
var $6c1fd9e6a8969628$var$ToggleGroupImpl = /*#__PURE__*/$jFibJ$react.forwardRef(function (props, forwardedRef) {
  var __scopeToggleGroup = props.__scopeToggleGroup,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$rovingFocus = props.rovingFocus,
    rovingFocus = _props$rovingFocus === void 0 ? true : _props$rovingFocus,
    orientation = props.orientation,
    dir = props.dir,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    toggleGroupProps = _objectWithoutProperties(props, ["__scopeToggleGroup", "disabled", "rovingFocus", "orientation", "dir", "loop"]);
  var rovingFocusGroupScope = $6c1fd9e6a8969628$var$useRovingFocusGroupScope(__scopeToggleGroup);
  var direction = $jFibJ$useDirection(dir);
  var commonProps = _objectSpread({
    role: 'group',
    dir: direction
  }, toggleGroupProps);
  return /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupContext, {
    scope: __scopeToggleGroup,
    rovingFocus: rovingFocus,
    disabled: disabled
  }, rovingFocus ? /*#__PURE__*/$jFibJ$react.createElement($jFibJ$Root, $jFibJ$babelruntimehelpersesmextends({
    asChild: true
  }, rovingFocusGroupScope, {
    orientation: orientation,
    dir: direction,
    loop: loop
  }), /*#__PURE__*/$jFibJ$react.createElement($jFibJ$Primitive.div, $jFibJ$babelruntimehelpersesmextends({}, commonProps, {
    ref: forwardedRef
  }))) : /*#__PURE__*/$jFibJ$react.createElement($jFibJ$Primitive.div, $jFibJ$babelruntimehelpersesmextends({}, commonProps, {
    ref: forwardedRef
  })));
});
/* -------------------------------------------------------------------------------------------------
 * ToggleGroupItem
 * -----------------------------------------------------------------------------------------------*/
var $6c1fd9e6a8969628$var$ITEM_NAME = 'ToggleGroupItem';
var $6c1fd9e6a8969628$export$b453109e13abe10b = /*#__PURE__*/$jFibJ$react.forwardRef(function (props, forwardedRef) {
  var valueContext = $6c1fd9e6a8969628$var$useToggleGroupValueContext($6c1fd9e6a8969628$var$ITEM_NAME, props.__scopeToggleGroup);
  var context = $6c1fd9e6a8969628$var$useToggleGroupContext($6c1fd9e6a8969628$var$ITEM_NAME, props.__scopeToggleGroup);
  var rovingFocusGroupScope = $6c1fd9e6a8969628$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
  var pressed = valueContext.value.includes(props.value);
  var disabled = context.disabled || props.disabled;
  var commonProps = _objectSpread({}, props, {
    pressed: pressed,
    disabled: disabled
  });
  var ref = $jFibJ$react.useRef(null);
  return context.rovingFocus ? /*#__PURE__*/$jFibJ$react.createElement($jFibJ$Item, $jFibJ$babelruntimehelpersesmextends({
    asChild: true
  }, rovingFocusGroupScope, {
    focusable: !disabled,
    active: pressed,
    ref: ref
  }), /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupItemImpl, $jFibJ$babelruntimehelpersesmextends({}, commonProps, {
    ref: forwardedRef
  }))) : /*#__PURE__*/$jFibJ$react.createElement($6c1fd9e6a8969628$var$ToggleGroupItemImpl, $jFibJ$babelruntimehelpersesmextends({}, commonProps, {
    ref: forwardedRef
  }));
});
/*#__PURE__*/
Object.assign($6c1fd9e6a8969628$export$b453109e13abe10b, {
  displayName: $6c1fd9e6a8969628$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/
var $6c1fd9e6a8969628$var$ToggleGroupItemImpl = /*#__PURE__*/$jFibJ$react.forwardRef(function (props, forwardedRef) {
  var __scopeToggleGroup = props.__scopeToggleGroup,
    value = props.value,
    itemProps = _objectWithoutProperties(props, ["__scopeToggleGroup", "value"]);
  var valueContext = $6c1fd9e6a8969628$var$useToggleGroupValueContext($6c1fd9e6a8969628$var$ITEM_NAME, __scopeToggleGroup);
  var singleProps = {
    role: 'radio',
    'aria-checked': props.pressed,
    'aria-pressed': undefined
  };
  var typeProps = valueContext.type === 'single' ? singleProps : undefined;
  return /*#__PURE__*/$jFibJ$react.createElement($jFibJ$Toggle, $jFibJ$babelruntimehelpersesmextends({}, typeProps, itemProps, {
    ref: forwardedRef,
    onPressedChange: function onPressedChange(pressed) {
      if (pressed) valueContext.onItemActivate(value);else valueContext.onItemDeactivate(value);
    }
  }));
});
/* -----------------------------------------------------------------------------------------------*/
var $6c1fd9e6a8969628$export$be92b6f5f03c0fe9 = $6c1fd9e6a8969628$export$af3ec21f6cfb5e30;
var $6c1fd9e6a8969628$export$6d08773d2e66f8f2 = $6c1fd9e6a8969628$export$b453109e13abe10b;
export { $6c1fd9e6a8969628$export$d1c7c4bcd9f26dd4 as createToggleGroupScope, $6c1fd9e6a8969628$export$af3ec21f6cfb5e30 as ToggleGroup, $6c1fd9e6a8969628$export$b453109e13abe10b as ToggleGroupItem, $6c1fd9e6a8969628$export$be92b6f5f03c0fe9 as Root, $6c1fd9e6a8969628$export$6d08773d2e66f8f2 as Item };